import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import type { UnreadNotifications } from '../../../features/citation/shared/types';
import { SKIP_ERROR_ALERT } from '../../http';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly http = inject(HttpClient);

  getUnreadNotifications(incidentIds: Array<string>): Observable<UnreadNotifications> {
    return this.http.post<UnreadNotifications>(`api/v1/court/incident/unread-notifications`, incidentIds, {
      context: new HttpContext().set(SKIP_ERROR_ALERT, true),
    });
  }
}
